import { render } from "./RegionSelector.vue?vue&type=template&id=228a4354&scoped=true"
import script from "./RegionSelector.vue?vue&type=script&lang=js"
export * from "./RegionSelector.vue?vue&type=script&lang=js"

import "./RegionSelector.vue?vue&type=style&index=0&id=228a4354&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228a4354"]])

export default __exports__